import { Action, createReducer, on } from '@ngrx/store';
import { ProductSearchResult } from '../../models/product-search-result.model';

import * as fromActions from '../actions/search.actions';

export const searchFeatureKey = 'search';

export enum Loaders {
  loadSearchResults = 'Load Search Results...'
}

export interface State {
  q?: string;
  searchResult: ProductSearchResult[];
  activeItem?: ProductSearchResult;
  loaders: Loaders[]
}

export const initialState: State = {
  searchResult: [],
  loaders: [],
  q: ''
};

export const reducer = createReducer(
  initialState,
  on(fromActions.setSearchQuery, (state, action) => ({
    ...state,
    q: action.q,
    loaders: state.loaders.concat(Loaders.loadSearchResults),
  })),
  on(fromActions.activateSearchItem, (state, action) => ({
    ...state,
    activeItem: action.item
  })),
  on(fromActions.loadSearchResults, (state, action) => ({
    ...state,
    loaders: state.loaders.concat(Loaders.loadSearchResults)
  })),
  on(fromActions.loadSearchResultsSuccess, (state, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.loadSearchResults),
    searchResult: action.results
  })),
  on(fromActions.loadSearchResultsFailure, (state, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.loadSearchResults)
  }))
);
